import axios from "@/http";
import store from '@/store/index'
import app from '@/main'

export default async (url, id = false, callback) => {
    
    app.$Progress.start()
    // const p1 = new Promise((res) => setTimeout(() => res("p1"), 3000));
    // await p1;

    const payload = id ? { id } : {}
    const res = await axios.post(
        url,
        payload,
        { headers: { Authorization: `Bearer ${store.state.token}` } }
    );
    // console.log(res.data.data)
    callback(res.data.data)
    
    app.$Progress.finish();
}